module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pgInner affairEdit"
  }, [_c('div', {
    staticClass: "headBar"
  }, [_vm._v("个人中心")]), _vm._v(" "), _c('div', {
    staticClass: "pgbody",
    style: ('height:' + _vm.pageH + 'px;')
  }, [_c('el-scrollbar', {
    ref: "scroller",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('tab-navs', {
    ref: "tabNavs",
    attrs: {
      "navs": _vm.navs
    },
    model: {
      value: (_vm.navAct),
      callback: function($$v) {
        _vm.navAct = $$v
      },
      expression: "navAct"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tabContent"
  }, [_c('Page', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.navAct === 0),
      expression: "navAct===0"
    }],
    ref: "Page",
    attrs: {
      "indata": _vm.param.dto
    },
    on: {
      "inited": _vm.readyHandle
    }
  })], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-c04c6dc6"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/cms/user/user_center/index.vue
// module id = 1556
// module chunks = 1